<template>
  <el-button type="success" round @click="addCateForm = true" class="cateBtn">
    添加分类
  </el-button>
  <!-- 添加分类表单 -->
  <el-dialog
    v-model="addCateForm"
    title="添加分类"
    width="500"
    destroy-on-close
    center
  >
    <span>
      <div class="mb-3 row">
        <label for="cateName" class="col-sm-2 col-form-label">分类名</label>
        <div class="col-sm-10">
          <input
            type="text"
            class="form-control"
            id="cateName"
            @blur="checkCateName"
          />
        </div>
      </div>
      <div class="mb-3 row">
        <label for="cateImg" class="col-sm-2 col-form-label">分类图</label>
        <div class="col-sm-10">
          <input class="form-control" type="file" id="cateImg" />
        </div>
      </div>
    </span>
    <div></div>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="addCateForm = false">取消</el-button>
        <el-button type="submit" @click="addCate()"> 提交 </el-button>
      </div>
    </template>
  </el-dialog>

  <el-dialog
    v-model="editCateForm"
    title="修改分类"
    width="500"
    destroy-on-close
    center
  >
    <span>
      <div class="mb-3 row">
        <label for="updateCateName" class="col-sm-2 col-form-label"
          >分类名</label
        >
        <div class="col-sm-10">
          <input
            type="text"
            class="form-control"
            id="updateCateName"
            :value="cateName"
            @blur="checkUpdateCateName"
          />
          <input type="hidden" id="updateCateId" :value="cateId" />
        </div>
      </div>
      <div class="mb-3 row">
        <label for="updateCateImg" class="col-sm-2 col-form-label"
          >分类图</label
        >
        <div class="col-sm-10">
          <input class="form-control" type="file" id="updateCateImg" />
        </div>
      </div>
    </span>
    <div></div>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="editCateForm = false">取消</el-button>
        <el-button type="submit" @click="editCate()"> 修改 </el-button>
      </div>
    </template>
  </el-dialog>

  <!-- 分类表格 -->
  <table class="table caption-top">
    <caption>
      全部分类
    </caption>
    <thead>
      <tr>
        <th scope="col">ID</th>
        <th scope="col">分类图片</th>
        <th scope="col">分类名</th>
        <th scope="col">操作</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="cate in cates" :key="cate.cateId">
        <th scope="row">{{ cate.cateId }}</th>
        <td><img :src="cate.cateImg" alt="" style="width: 30px" /></td>
        <td>{{ cate.cateName }}</td>
        <td>
          <el-button type="warning" plain @click="editCateStatus(cate)"
            >编辑</el-button
          >
          <el-popconfirm
            title="确认要删除吗？"
            @confirm="deleteCate(cate.cateId, cate.cateImg)"
            confirm-button-text="确认"
            cancel-button-text="取消"
            confirm-button-type="danger"
          >
            <template #reference>
              <el-button type="danger" plain>删除</el-button>
            </template>
          </el-popconfirm>
        </td>
      </tr>
    </tbody>
  </table>

  <nav aria-label="...">
    <ul class="pagination" style="float: center">
      <li class="page-item" @click="click_page(-2)">
        <a class="page-link" href="#">前一页</a>
      </li>
      <li
        :class="'page-item ' + page.is_active"
        v-for="page in pages"
        :key="page.number"
        @click="click_page(page.number)"
      >
        <a class="page-link" href="#">{{ page.number }}</a>
      </li>
      <li class="page-item" @click="click_page(-1)">
        <a class="page-link" href="#">后一页</a>
      </li>
    </ul>
  </nav>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { ElMessage } from "element-plus";
import { useRoute } from "vue-router";
import router from "@/router/index";
import $ from "jquery";

const addCateForm = ref(false);
const editCateForm = ref(false);
let cateNameFlag = false;
let updateCateNameFlag = false;
let cates = ref([]);
let current_page = 1;
let total_cate = 0;
let cateName = ref("");
let cateId = ref(0);
let pages = ref([]);
const Route = useRoute(); //获取到值

// 在组件初始化时获取路由参数并设置为 current_page
onMounted(() => {
  // 获取路由参数并设置为 current_page
  console.log("当前页", Route.params.page);
  current_page = parseInt(Route.params.page) || 1;
  pullCate(current_page);
});

// 加载分类信息
const pullCate = (page) => {
  current_page = page;
  const token = localStorage.getItem("token");
  $.ajax({
    url: "http://124.222.105.205:5000/api/cate/getCateList",
    data: {
      page,
    },
    type: "post",
    headers: {
      Authorization: "Bearer " + token,
    },
    success(resp) {
      cates.value = resp.data.list;
      total_cate = resp.data.total;
      udpate_pages();
    },
    error(resp) {
      console.log(resp);
    },
  });
};

const click_page = (page) => {
  if (page === -2) page = current_page - 1;
  else if (page === -1) page = current_page + 1;
  let max_pages = parseInt(Math.ceil(total_cate / 5));

  if (page >= 1 && page <= max_pages) {
    pullCate(page);
  }
};

const udpate_pages = () => {
  let max_pages = parseInt(Math.ceil(total_cate / 5));
  let new_pages = [];
  for (let i = current_page - 2; i <= current_page + 2; i++) {
    if (i >= 1 && i <= max_pages) {
      new_pages.push({
        number: i,
        is_active: i === current_page ? "active" : "",
      });
    }
  }
  pages.value = new_pages;
  router.push({ name: "CateView", params: { page: current_page } });
};

//添加分类
const addCate = () => {
  let cateName = $("#cateName").val();

  if (!cateNameFlag || $("#cateImg")[0].files[0] == "") {
    ElMessage({
      type: "error",
      message: "分类名或文件错误！",
    });
    return false;
  }

  const token = localStorage.getItem("token");
  var formData = new FormData();
  formData.append("file", $("#cateImg")[0].files[0]);
  formData.append("cateName", cateName); // 添加分类名
  $.ajax({
    url: "http://124.222.105.205:5000/api/cate/addCate",
    type: "post",
    data: formData,
    headers: {
      Authorization: "Bearer " + token,
    },
    processData: false, // 告诉jQuery不要去处理发送的数据
    contentType: false, // 告诉jQuery不要去设置Content-Type请求头
    dataType: "text",
    success: function (resp) {
      let result = JSON.parse(resp);
      if (result.code == "200") {
        ElMessage({
          type: "success",
          message: result.msg,
        });
        addCateForm.value = false;
        location.reload();
      } else {
        ElMessage({
          type: "error",
          message: result.msg,
        });
      }
    },
    error: function () {
      ElMessage({
        type: "error",
        message: "添加分类失败！",
      });
    },
  });
  return false;
};

// 删除分类
const deleteCate = (cateId, cateImg) => {
  const token = localStorage.getItem("token");
  $.ajax({
    url: "http://124.222.105.205:5000/api/cate/deleteCate",
    type: "post",
    data: {
      cateId: cateId,
      cateImg: cateImg,
    },
    headers: {
      Authorization: "Bearer " + token,
    },
    success(resp) {
      if (resp.code == "200") {
        ElMessage({
          type: "success",
          message: resp.msg,
        });
        location.reload();
      } else {
        ElMessage({
          type: "error",
          message: resp.msg,
        });
      }
    },
    error() {
      ElMessage({
        type: "error",
        message: "删除失败",
      });
    },
  });
};

// 修改分类弹出表单，并修改状态
const editCateStatus = (cate) => {
  editCateForm.value = true;
  cateName = cate.cateName;
  cateId = cate.cateId;
};

// 修改分类
const editCate = () => {
  checkUpdateCateName();
  if (updateCateNameFlag) {
    const token = localStorage.getItem("token");

    let updateCateName = $("#updateCateName").val();
    let updateCateId = $("#updateCateId").val();


    var formData = new FormData();
    formData.append("cateName", updateCateName); // 添加分类名
    formData.append("cateId", updateCateId); // 添加分类id
    // 检查是否存在文件
    if ($("#updateCateImg")[0].files.length > 0) {
      formData.append("file", $("#updateCateImg")[0].files[0]);
    }

    $.ajax({
      url: "http://124.222.105.205:5000/api/cate/editCate",
      type: "post",
      data: formData,
      headers: {
        Authorization: "Bearer " + token,
      },
      processData: false, // 告诉jQuery不要去处理发送的数据
      contentType: false, // 告诉jQuery不要去设置Content-Type请求头
      dataType: "text",
      success: function (resp) {
        let result = JSON.parse(resp);
        if (result.code == "200") {
          ElMessage({
            type: "success",
            message: result.msg,
          });
          addCateForm.value = false;
          location.reload();
        } else {
          ElMessage({
            type: "error",
            message: result.msg,
          });
        }
      },
      error: function () {
        ElMessage({
          type: "error",
          message: "修改分类失败！",
        });
      },
    });
  } else {
    ElMessage({
      type: "error",
      message: "请检查分类名！",
    });
  }
};

// 验证用户名
const checkCateName = () => {
  const cateName = $("#cateName").val();

  const token = localStorage.getItem("token");
  $.ajax({
    url: "http://124.222.105.205:5000/api/cate/hasCate",
    type: "post",
    data: {
      cateName: cateName,
    },
    headers: {
      Authorization: "Bearer " + token,
    },
    success(resp) {
      if (resp.code == "200") {
        changeStatus("cateName", true);
        cateNameFlag = true;
      } else {
        changeStatus("cateName", false);
        cateNameFlag = false;
      }
    },
    error() {
      changeStatus("cateName", false);
      cateNameFlag = false;
    },
  });
};

// 验证修改后用户名
const checkUpdateCateName = () => {
  const updateCateName = $("#updateCateName").val();

  const token = localStorage.getItem("token");
  let preCateName = cateName;
  if (updateCateName == preCateName) {
    changeStatus("updateCateName", true);
    updateCateNameFlag = true;
    return;
  }
  $.ajax({
    url: "http://124.222.105.205:5000/api/cate/hasCate",
    type: "post",
    data: {
      cateName: updateCateName,
    },
    headers: {
      Authorization: "Bearer " + token,
    },
    success(resp) {
      if (resp.code == "200") {
        changeStatus("updateCateName", true);
        updateCateNameFlag = true;
      } else {
        changeStatus("updateCateName", false);
        updateCateNameFlag = false;
      }
    },
    error() {
      changeStatus("updateCateName", false);
      updateCateNameFlag = false;
    },
  });
};

// 改变input框
const changeStatus = (name, status) => {
  if (status) {
    // 改变为空
    $("#" + name).css("border", "1px solid green"); // 清空边框样式
  } else {
    // 改变为红色实线边框
    $("#" + name).css("border", "1px solid red");
  }
};
</script>

<style scoped>
.cateBtn {
  float: right;
}
</style>